import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getActiveHeader } from "../../../redux/home/actions";
import SubscriptionB2C from "./SubscriptionB2CPage";
import HomePage from "../../HomePage";
import { SessionKeys } from "../../../utils/AppUtils";

const ConditionalRenderingForSubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => {
    console.log("state---", state);
    return state.auth.authBroker;
  });
  console.log("authbroker--", authBroker,userRole != "customer"&&!authBroker?.payload?.user?.display_subscription_menu&&localStorage.getItem(SessionKeys.API_TOKEN_BROKER));
  useEffect(() => {
    if (
      userRole != "customer" &&
      !authBroker?.payload?.user?.display_subscription_menu && localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    ) {
      dispatch(getActiveHeader("home"));
      navigate("/home");
    } else {
      dispatch(getActiveHeader("subscription"));
      navigate("/subscription");
    }
  }, [navigate, authBroker, userRole]);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Adjust the timing as needed
  }, []);
  return (
    <>
      {userRole != "customer" &&
      !authBroker?.payload?.user?.display_subscription_menu && localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ? (
        <HomePage />
      ) : (
        <SubscriptionB2C />
      )}
    </>
  );
};

export default ConditionalRenderingForSubscription;
